import { ActionTypes } from './constants';

export const reducer = (state = {}, action = {}) => {
    switch (action.type) {
        case ActionTypes.SET_PAGE_TRACE_ID:
            return {
                ...state,
                ...action.payload,
            };
        case ActionTypes.SET_BOT_INFO:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
